import React from 'react'
import PropTypes from 'prop-types'
import {Box, Divider, Grid, Stack, Image, useMultiStyleConfig} from '@chakra-ui/react'
import CustomLink from '../custom-link'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

const QuickLinks = ({quickLinksSchema}) => {
    const styles = useMultiStyleConfig('Footer')
    const {buildUrl} = useMultiSite()

    const columnsDesktop =
        (quickLinksSchema.length === 1 && '1fr') ||
        (quickLinksSchema.length === 2 && '1fr 1px 1fr') ||
        (quickLinksSchema.length === 3 && '1fr 1px 1fr 1px 1fr') ||
        '1fr 1px 1fr 1px 1fr 1px 1fr'

    const columnsMobile =
        (quickLinksSchema.length === 1 && '1fr') || (quickLinksSchema.length >= 2 && '1fr 1px 1fr')

    return (
        <Grid
            {...styles.iconsBenefitSection}
            gridTemplateColumns={{base: columnsMobile, lg: columnsDesktop}}
        >
            {quickLinksSchema.map((item, index) => {
                const isExternalUrl = !!item?.is_external_url
                const isLastItem = index === quickLinksSchema.length - 1
                const isSecondItem = index === 1
                // const isSvg = item?.icon?.content_type.includes('svg')

                const stackProps = {}
                if (quickLinksSchema.length === 3 && index === 2) {
                    stackProps.gridColumn = {base: '1 / span 4', lg: 'auto'}
                    stackProps.justifySelf = {base: 'center', lg: 'auto'}
                    stackProps.textAlign = {base: 'center', lg: 'auto'}
                }

                return (
                    <React.Fragment key={index}>
                        <Stack {...styles.benefitStack} {...stackProps}>
                            <Image
                                src={item?.icon?.url}
                                alt={item?.icon?.description}
                                {...styles.benefitIcons}
                            />
                            <Box>
                                <CustomLink
                                    isExternal={isExternalUrl}
                                    href={
                                        isExternalUrl ? item?.cta?.href : buildUrl(item?.cta?.href)
                                    }
                                    {...styles.benefitText}
                                >
                                    {item?.cta?.title}
                                </CustomLink>
                            </Box>
                        </Stack>
                        {!isLastItem && (
                            <Divider
                                orientation="vertical"
                                display={{
                                    base: isSecondItem ? 'none' : 'block',
                                    md: isSecondItem ? 'none' : 'block',
                                    lg: 'block',
                                }}
                                {...styles.dividerRule}
                            />
                        )}
                        {quickLinksSchema.length > 1 && isSecondItem && !isLastItem && (
                            <Divider
                                display={{base: 'block', lg: 'none'}}
                                gridColumn="1 / -1"
                                {...styles.dividerRule}
                            />
                        )}
                    </React.Fragment>
                )
            })}
        </Grid>
    )
}

QuickLinks.propTypes = {
    quickLinksSchema: PropTypes.arrayOf(
        PropTypes.shape({
            icon: PropTypes.shape({url: PropTypes.string, title: PropTypes.string}),
            cta: PropTypes.shape({href: PropTypes.string, title: PropTypes.string}),
            is_external_url: PropTypes.bool,
        }),
    ).isRequired,
}

export default QuickLinks
